var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.872 16.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.ec8dc441b76fb2966a9244c04fc914bd{fill:currentColor;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H16.872V16.872H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ec8dc441b76fb2966a9244c04fc914bd",
    d: "M9.624,9.624A2.812,2.812,0,1,0,6.812,6.812,2.811,2.811,0,0,0,9.624,9.624Zm0,1.406C7.747,11.03,4,11.972,4,13.842v.7a.705.705,0,0,0,.7.7h9.842a.705.705,0,0,0,.7-.7v-.7C15.248,11.972,11.5,11.03,9.624,11.03Z",
    transform: "translate(-1.188 -1.188)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonProfile);
export default __webpack_public_path__ + "static/media/person-profile.f1e8b69b6d5f95c9b64cd23b525d4e0c.svg";
export { ForwardRef as ReactComponent };